import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  ResultadoParte9_2ResultadoSalasExistentesDto,
  ResultadoParte9_3ResultadoSalasNecessariasDto,
  ResultadoParte9_4DemandaPorNovasSalasDto,
} from '../../dtos/resultados-parte9.dto';

interface LinhaSalasDeAula {
  // Preenchida só na primeira linha de cada etapa (a célula ocupa as linhas Urbana e Rural).
  etapa?: string[];
  area: 'Urbana' | 'Rural';
  necessarias: number;
  demanda: number;
}

// Tabela "Salas de aula: diagnóstico e projeção" (#1472, spec NovasSalas.md dos relatórios).
@Component({
  selector: 'app-tabela-salas-de-aula',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './tabela-salas-de-aula.component.html',
  styleUrl: './tabela-salas-de-aula.component.scss',
})
export class TabelaSalasDeAulaComponent {
  @Input() salasExistentes?: ResultadoParte9_2ResultadoSalasExistentesDto;
  @Input() salasNecessarias?: ResultadoParte9_3ResultadoSalasNecessariasDto;
  @Input() demandaNovasSalas?: ResultadoParte9_4DemandaPorNovasSalasDto;
  @Input() estiloProjecao = false;
  @Input() carregandoPdf = false;
  @Output() pdfClick = new EventEmitter<void>();

  get linhas(): LinhaSalasDeAula[] {
    const n = this.salasNecessarias;
    const d = this.demandaNovasSalas;
    return [
      { etapa: ['Educação Infantil'], area: 'Urbana', necessarias: n?.resultadoNumSalasNecessariasEdInfantilUrbana ?? 0, demanda: d?.resultadoDemandaSalasEdInfantilUrbana ?? 0 },
      { area: 'Rural', necessarias: n?.resultadoNumSalasNecessariasEdInfantilRural ?? 0, demanda: d?.resultadoDemandaSalasEdInfantilRural ?? 0 },
      {
        etapa: ['Ensino Fundamental anos iniciais e finais', 'Ensino Médio', 'EJA'],
        area: 'Urbana',
        necessarias: n?.resultadoNumSalasNecessariasEnsFunEnsMedioEjaUrbana ?? 0,
        demanda: d?.resultadoDemandaSalasEnsFunEnsMedioEjaUrbana ?? 0,
      },
      { area: 'Rural', necessarias: n?.resultadoNumSalasNecessariasEnsFunEnsMedioEjaRural ?? 0, demanda: d?.resultadoDemandaSalasEnsFunEnsMedioEjaRural ?? 0 },
    ];
  }
}
